import { render, staticRenderFns } from "./step6.vue?vue&type=template&id=a30176f0"
import script from "./step6.vue?vue&type=script&lang=js"
export * from "./step6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports